import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ADMIN_URL_PROVIDER, BASE_URL_PROVIDER} from './app-provider';
import {XmedicalUiModule, DayJsDateAdapter, DAYJS_DATE_FORMATS} from '@xmedical/ui';
import {CoreModule} from './core/core.module';
import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';
import {
  ApplicationInterceptor,
  HttpErrorInterceptor,
  PermissionProvider,
  PracticeInterceptor,
  PUSHER_CONFIG,
  RequestTracingInterceptor,
  WebSocketInterceptor,
  XMedicalCoreModule
} from '@xmedical/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {HttpProgressInterceptor, FILE_STORAGE_PROVIDER, CoreFileStorageProvider} from '@xmedical/uploads';
import {SentryErrorHandler} from './core/errors/sentry-error-handler';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {CoreService} from './core/services/core.service';
import {authInterceptor, provideAuth} from 'angular-auth-oidc-client';
import {authConfig} from './core/auth/auth.config';
import {SessionInterceptor} from './core/interceptors/session.interceptor';

@NgModule({
  declarations: [
    AppComponent,
  ],
  bootstrap: [
    AppComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    XMedicalCoreModule.forRoot({
      apiUrl: environment.api,
      adminApiUrl: environment.adminApi,
      version: environment.version,
      storageKeys: {
        accessToken: 'access_token',
        selectedPractice: 'selected_practice',
        installationId: 'installation_id',
        sessionId: 'session_state',
        socketId: 'socket_id'
      }
    }),
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    AppRoutingModule,
    CoreModule,
    XmedicalUiModule,
    ServiceWorkerModule.register('push-sw.js', {enabled: environment.production && environment.serviceWorkerEnabled}),
    BrowserAnimationsModule], providers: [
    // Legacy providers - can be removed once app is fully migrated to @xmedical/core
    BASE_URL_PROVIDER,
    ADMIN_URL_PROVIDER,
    {provide: PUSHER_CONFIG, useValue: environment.pusher},
    CoreFileStorageProvider,
    {provide: FILE_STORAGE_PROVIDER, useExisting: CoreFileStorageProvider},
    {provide: ErrorHandler, useClass: SentryErrorHandler},
    {provide: HTTP_INTERCEPTORS, useClass: PracticeInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ApplicationInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: WebSocketInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: RequestTracingInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpProgressInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true},
    {provide: DateAdapter, useClass: DayJsDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: DAYJS_DATE_FORMATS},
    {provide: PermissionProvider, useExisting: CoreService},
    provideAuth(authConfig),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([authInterceptor()]))
  ]
})
export class AppModule {
}
